import React, { useState } from 'react';
import { SvgIcon, Button, makeStyles } from '@material-ui/core';
import ShieldCheckmarkIcon from '../../../icons/shield-checkmark.svg';
import ButtonCardWithFunction from '../../Helpers/Buttons/ButtonCardWithFunction';
import NeedsCalculator from './NeedsCalculator';
import PropTypes from 'prop-types';
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import './NeedsAnalysisButton.scss'
import { useHistory } from 'react-router-dom';

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)"

const useStyles = makeStyles(theme => ({
  white: {
    color: theme.palette.primary.main,
    backgroundColor: white,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: offWhite
    },
    '&:focus': {
      outline: 'none'
    }
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },

}));

export default function NeedsAnalysisButton(props) {
  const classes = useStyles();
  const history = useHistory();

  const shape = props.shape ? props.shape : 'wide';

  const title = props.title || "NEEDS ANALYSIS";
  const icon = props.icon || <SvgIcon component={ShieldCheckmarkIcon} />;

  const [modalNeedsCalculatorIsOpen, setModalNeedsCalculatorIsOpen] = useState(false);

  const setCoverageAmount = (face) => {
    if (props.setCoverageAmount != null) {
      props.setCoverageAmount(face)
    }
    else {
      sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, face);
      window.location = "/landing/term-insurance";
    }
  };

  const modalNeedsCalculatorFields = {
    modalNeedsCalculatorIsOpen: modalNeedsCalculatorIsOpen,
    setModalNeedsCalculatorIsOpen: setModalNeedsCalculatorIsOpen,
    setCoverageAmount: setCoverageAmount,
    minCoverageAmount: props.minCoverageAmount || 250000,
    maxCoverageAmount: props.maxCoverageAmount || 10000000,
  };

  const redirectToPolicyReview = () => {
    if (props.enablePolicyReview) {
      history.push('/policy-review');
      window.scroll(0, 0);
    }
    else {
      setModalNeedsCalculatorIsOpen(true);
    }
  };

  return (
    <div className="needs-analysis-button">
      <React.Fragment>
        {props.type === "quote-screen" ?
          <Button type="submit"
            onClick={() => setModalNeedsCalculatorIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`${props.isPrequote ? `${classes.white}` : `quote-needs-button ${classes.white}`}`}
          >
            {props.isPrequote ? <SvgIcon component={ShieldCheckmarkIcon} color="primary" /> : <div className={`icon-container mb-0 ${classes.lightBackground}`}><SvgIcon component={ShieldCheckmarkIcon} color="primary" /></div>}
            <span className="name">&nbsp;{title}</span>
          </Button>
          :
          <ButtonCardWithFunction id={0}
            name={title}
            onClick={redirectToPolicyReview}
            shape={shape}
            icon={icon}
            className={classes.white}
            isFromHomePage={props.isFromHomePage}
          />
        }
        <NeedsCalculator fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} isCustomTerm={props.isCustomTerm}/>
      </React.Fragment>
    </div>
  );
}

NeedsAnalysisButton.propTypes = {
  minCoverageAmount: PropTypes.number,
  maxCoverageAmount: PropTypes.number,
  shape: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Tools/NeedsAnalysis/NeedsAnalysisButton.js